'use client';

import { cn } from '@/lib/utils';
import Image from '@/helpers/Image';

import dots from '@/public/text-only-crypto/dots.png';
import halftone from '@/public/text-only-crypto/halftone-dark.png';

export function DotTexture({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        'absolute max-lg:hidden lg:flex h-[58.875rem] w-[104.631rem] items-center justify-center mix-blend-difference opacity-70 pointer-events-none',
        className,
      )}
      style={{
        maskImage: 'url(/text-only-crypto/dots-mask.svg)',
        WebkitMaskImage: 'url(/text-only-crypto/dots-mask.svg)',
        maskSize: '85.75rem 58.875rem',
        WebkitMaskSize: '85.75rem 58.875rem',
        maskPosition: '16.006rem 4.375rem',
        WebkitMaskPosition: '16.006rem 4.375rem',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
      }}
    >
      <div className="relative h-[104.631rem] w-[58.875rem] shrink-0 rotate-90 -scale-y-100">
        <Image
          src={dots}
          alt=""
          className="absolute inset-0 !w-full !h-full object-cover"
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  );
}

export function HalftoneTiles({
  tiles,
  width,
  height,
  opacity,
}: {
  tiles: string[];
  width: string;
  height: string;
  opacity: number;
}) {
  return (
    <div
      aria-hidden
      className="absolute inset-0 overflow-clip pointer-events-none"
    >
      {tiles.map((position) => (
        <div
          key={position}
          className={cn(
            'absolute top-0 flex items-center justify-center mix-blend-exclusion',
            position,
          )}
          style={{ width, height }}
        >
          <div
            className="relative shrink-0 rotate-90 overflow-hidden"
            style={{ width: height, height: width, opacity }}
          >
            <Image
              src={halftone}
              alt=""
              className="absolute inset-0 !w-full !h-full object-cover"
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export function DarkHalftone() {
  return (
    <HalftoneTiles
      tiles={['left-[calc(50%-136.75rem)]', 'left-[calc(50%-6.25rem)]']}
      width="max(130.5rem, 54.375vw)"
      height="max(173.5rem, 72.292vw)"
      opacity={0.14}
    />
  );
}
